import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { comparerByAlphabet } from '@app/comparers';

import {
  DestinationCenterActionTypes,
  DestinationCenterActionsUnion
} from '@core/actions/destination-center.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DestinationCenter } from '@app/models/destination-center';

export interface State extends EntityState<DestinationCenter> {
  loading: boolean;
  loaded: boolean;
  selectedBusiness: string;
  CountryId: number;
  isBusy: boolean;
}

export const adapter: EntityAdapter<DestinationCenter> = createEntityAdapter<
  DestinationCenter
>({
  selectId: (destinationCenter: DestinationCenter) => destinationCenter.id
  // sortComparer: comparerByAlphabet('ASC', 'name')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  selectedBusiness: null,
  CountryId: null,
  isBusy: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: DestinationCenterActionsUnion
) {
  switch (action.type) {
    case DestinationCenterActionTypes.Load:
      return {
        ...state,
        loading: true
      };

    // case DestinationCenterActionTypes.GetAll:
    case DestinationCenterActionTypes.LoadAll:
      return {
        ...state,
        loading: true,
        isBusy: true
      };
    
    // case DestinationCenterActionTypes.GetAllSuccess:
    case DestinationCenterActionTypes.LoadSuccess:
      return adapter.addAll(action.destinationCenters, {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false
      });

    case DestinationCenterActionTypes.Create:
    case DestinationCenterActionTypes.Delete:
    case DestinationCenterActionTypes.Update:
      return {
        ...state,
        isBusy: true
      }

    case DestinationCenterActionTypes.CreateSuccess:
    case DestinationCenterActionTypes.CreateFail:
    case DestinationCenterActionTypes.UpdateSuccess:
    case DestinationCenterActionTypes.UpdateFail:
    case DestinationCenterActionTypes.DeleteSuccess:
    case DestinationCenterActionTypes.DeleteFail:
      return {
        ...state,
        isBusy: false
      }

    case DestinationCenterActionTypes.SelectedBusiness:
      return {
        ...state,
        selectedBusiness: action.businessUnit,
        CountryId: action.CountryId
      };

    case DestinationCenterActionTypes.ClearDestinationCenters:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectedBusinessUnit = (state: State) => state.selectedBusiness;
export const selectedCountryId = (state: State) => state.CountryId;

export const getState = createFeatureSelector<State>('destinationCenters');
export const getAll = createSelector(
  getState,
  selectAll
);

export const getSelectedBusiness = createSelector(
  getState,
  selectedBusinessUnit
);

export const getCountryId = createSelector(
  getState,
  selectedCountryId
);

export const getDestinationByBusiness = createSelector(
  getSelectedBusiness,
  getCountryId,
  getAll,
  (businessUnit, CountryId, destinationCenters) => {
    console.log('businessUnit', businessUnit, CountryId);
    return businessUnit
      ? destinationCenters.filter(
          x => x.code === businessUnit && x.CountryId === CountryId
        )
      : destinationCenters;
  }
);

export const getAllDestinationCenter = createSelector(
  getState,
  getAll
);

export const getAllDestination = createSelector(
  getState,
  getAll
);

export const getIsBusy = createSelector(
  getState,
  (state: State) => state.isBusy
);
